import { Button } from '@/components/ui/deprecated-button'
import { Loader2 } from 'lucide-react'

export function SalaryEditButton({
  onEditButtonClick,
  isEditButtonLoading,
}: {
  onEditButtonClick: () => void
  isEditButtonLoading: boolean
}) {
  return (
    <Button
      variant="outline"
      onClick={() => onEditButtonClick()}
      disabled={isEditButtonLoading}
      className="w-full mt-2"
    >
      {isEditButtonLoading ? (
        <Loader2 className="w-4 h-4 mr-2 animate-spin" />
      ) : null}
      View
    </Button>
  )
}
